<template>
  <div class="w-100">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'TabsChildC',
  extends: {},
  props: {},
  data(){
    return{};
  },
  components: {},
  computed: {},
  watch: {},
  methods: {},
  beforeCreate(){},
  mounted(){}
}
</script>
